import React, { useState } from "react";
import { getLegsToRender, formatDuration, getLegDerivedValues } from "../../utilities/quoteTableExpandedUtils";
import fromIcon from "../../assets/icons/departure-time.svg";
import toIcon from "../../assets/icons/arrival-time.svg";
import calendarIcon from "../../assets/icons/calendar.svg";
import fuelStopIcon from "../../assets/icons/fuel-stop-dark.svg";
import infoIcon from "../../assets/icons/info-blue.svg";
import personIconDark from "../../assets/icons/person-dark.svg";
import timeIcon from "../../assets/icons/time.svg";
import durationIcon from "../../assets/icons/duration.svg";
import luggageIcon from "../../assets/icons/luggage-dark.svg";
import { FUEL_STOP_INFO } from "../../utilities/quoteMessaging";
import ArrivalTime from "../shared/ArrivalTime";

const QuoteTableExpandedMobile = ({
    legData,
    departureTime,
    arrivalTime,
    duration,
    fuelStop,
    passengers,
    luggage,
    departureAirport,
    arrivalAirport,
}) => {
    const [openDurationIndex, setOpenDurationIndex] = useState(null);
    const legsToRender = getLegsToRender(legData, departureAirport, arrivalAirport, passengers, luggage);

    if (legsToRender.length === 0) {
        return (
            <div className="quote-table-expanded-mobile">
                <div className="quote-table-expanded-mobile__no-data">No flight schedule data available</div>
            </div>
        );
    }

    return (
        <div className="quote-table-expanded-mobile">
            {legsToRender.map((leg, index) => {
                const {
                    formattedDepartureDate,
                    departureTimeFormatted,
                    arrivalTimeFormatted,
                    legDepartureDate,
                    legArrivalDate,
                    legFuelStop,
                    legDuration,
                } = getLegDerivedValues(leg, index, {
                    departureTime,
                    arrivalTime,
                    duration,
                    fuelStop,
                });
                return (
                    <div key={index} className="quote-table-expanded-mobile__item">
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={calendarIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Dep Date:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">{formattedDepartureDate}</div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={timeIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Dep Time:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">{departureTimeFormatted}</div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={fromIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>From:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value quote-table-expanded-mobile__value--duration">
                                {leg.departureAirport?.longName || "-"}
                            </div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={durationIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Duration:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">
                                {legFuelStop > 0 ? (
                                    <>
                                        <span>{formatDuration(legDuration)}</span>
                                        <span className="quote-table-expanded-mobile__fuel-stop">
                                            <img
                                                src={fuelStopIcon}
                                                alt=""
                                                className="quote-table-expanded-mobile__fuel-stop-icon"
                                            />
                                            {legFuelStop === 1 ? "Fuel stop" : `${legFuelStop} Fuel stops`}
                                        </span>
                                        <button
                                            type="button"
                                            className="quote-table-expanded-mobile__fuel-stop-toggle"
                                            onClick={() =>
                                                setOpenDurationIndex(openDurationIndex === index ? null : index)
                                            }
                                            aria-expanded={openDurationIndex === index}
                                            aria-label="Fuel stop information"
                                        >
                                            <img
                                                src={infoIcon}
                                                alt=""
                                                className="quote-table-expanded-mobile__fuel-stop-info-icon"
                                            />
                                        </button>
                                    </>
                                ) : (
                                    formatDuration(legDuration)
                                )}
                            </div>
                        </div>
                        {legFuelStop > 0 && openDurationIndex === index && (
                            <div className="quote-table-expanded-mobile__duration-info">{FUEL_STOP_INFO}</div>
                        )}
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={toIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>To:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">
                                {leg.arrivalAirport?.longName || "-"}
                            </div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={timeIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Arr Time:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">
                                {arrivalTimeFormatted === "-" ? (
                                    "-"
                                ) : (
                                    <ArrivalTime
                                        time={arrivalTimeFormatted}
                                        departureDate={legDepartureDate}
                                        arrivalDate={legArrivalDate}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={personIconDark} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Pax:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">
                                {leg.passengers || passengers || "-"}
                            </div>
                        </div>
                        <div className="quote-table-expanded-mobile__row">
                            <div className="quote-table-expanded-mobile__label">
                                <span className="quote-table-expanded-mobile__icon-wrapper">
                                    <img src={luggageIcon} alt="" className="quote-table-expanded-mobile__icon" />
                                </span>
                                <span>Luggage:</span>
                            </div>
                            <div className="quote-table-expanded-mobile__value">
                                {leg.luggage !== undefined && leg.luggage !== null ? leg.luggage : "-"}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default QuoteTableExpandedMobile;
